module.exports = __webpack_public_path__ + "static/design-6462884d493a738766a4de683811ace9.png";